// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1zF79","footer":"ModalFilter_footer__2x_Gw"};